.chart {
    width: calc(100% - 201px);
    position: absolute;
    bottom: 0;
    left: 201px;
}
